import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';

import GlobalStyles from '@styles/GlobalStyles';
import theme from '@styles/theme';
import { getCookie } from '@utils/cookie';
import { userVar } from './store';
import { SEE_MY_ADMIN_INFO } from '@graphql/queries';
import { Query, Admin } from '@graphql/types';

import Router from './Router';

if (process.env.NODE_ENV === 'production') {
    console.log = function no_console() {};
    console.warn = function no_console() {};
    console.info = function no_console() {};
}

function App() {
    const isLoggedIn = getCookie('PDT') ?? false;
    const { pathname } = useLocation();

    const { data, error } = useQuery<Pick<Query, 'seeMyAdminInfo'>>(
        SEE_MY_ADMIN_INFO,
        {
            skip: !isLoggedIn
        }
    );

    useEffect(() => {
        if (data) {
            userVar(data.seeMyAdminInfo as Admin);
        } else if (error) {
            console.log(error.message);
        }
    }, [data, error]);

    useEffect(() => {
        document.oncontextmenu = () => {
            return false;
        };
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <ToastContainer />
            <Router isLoggedIn={isLoggedIn} />
        </ThemeProvider>
    );
}

export default App;
